import Http from "./Http";

export class SocialsService extends Http {
  /**
   * Metamask login API
   * @param {Object} body
   * @param {string} body.address
   * @param {string} body.signature
   * @param {string?=} body.referral
   */
  loginWithMetamask(body) {
    return this.post("/socials/sessions/metamask", body);
  }

  /**
   * Create Metamask nonce
   * @param {Object} body
   * @param {string} body.address
   * @param {Object} config
   * @param {boolean} config.skipAuth Wont add Authorization header if `true`
   */
  createNonce(body, config) {
    return this.put("/socials/metamask/nonce", body, config);
  }

  /**
   * Connect metamask to account
   * @param {Object} body
   * @param {string} body.address
   * @param {string} body.signature
   */
  connectMetamask(body) {
    return this.post("/socials/metamask", body);
  }

  /**
   * Disconnect metamask from account
   */
  disconnectMetamask() {
    return this.delete("/socials/metamask");
  }

  /**
   * Google login API
   * @param {Object} body
   * @param {string} body.token
   * @param {string?=} body.referral
   */
  loginWithGoogle(body) {
    return this.post("/socials/sessions/google", body);
  }

  /**
   * Google login API
   * @param {Object} body
   * @param {string} body.token
   * @param {string} body.verifierToken
   * @param {string?=} body.referral
   */
  loginWithTwitter(body) {
    return this.post("/socials/sessions/twitter", body);
  }

  /**
   * Get twitter login link
   */
  getTwitterLoginLink() {
    return this.get("/socials/sessions/twitter/link");
  }

  /**
   * Twitch login API
   * @param {Object} body
   * @param {string} body.token
   * @param {string?=} body.referral
   * @param {string?=} body.trackingCode
   */
  loginWithTwitch(body) {
    return this.post("/socials/sessions/twitch", body);
  }

  /**
   * Add an email to existing account created via socials
   * @param {Object} body
   * @param {string} body.email
   */
  addEmail(body) {
    return this.post("/socials/email", body);
  }
}

export default new SocialsService();
